require('./removeScheduledTransferSecurityConfirmation.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ helpers
const DateHelper = require('utilities/dateHelper');
const { toCamelCase } = require('utilities/stringHelper');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKButton } = require('components/commons/OKButton/OKButton');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript , CONFIRMATION_SCRIPT_GREETING , CONFIRMATION_SCRIPT_AGREEMENT} = require('components/contactCenter/confirmScript/confirmationScript');

// @ constants
const { REMOVE_SCHEDULED_TRANSFER_ID } = require('constants/operationTypes');
const { getTranslatedCountry } = require('constants/countries');
const {
    DATE_FORMAT_ES,
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    DEFERRED_TRANFERS
} = require('constants/index');

const {
    CC_PERIODICITY_DAILY,
    CC_PERIODICITY_WEEKLY,
    CC_PERIODICITY_CUSTOM,
} = require('constants/contactCenter/transfers');


class RemoveScheduledTransferSecurityConfirmation extends React.Component {
    constructor() {
        super();
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
    }

    builBeneficiaryContent() {
        const { immScheduledTransfer } = this.props;
        const beneficiaryName = immScheduledTransfer.getIn(['details', 'name']);
        const beneficiaryIban = `IBAN ${immScheduledTransfer.getIn(['details', 'beneficiaryFullIban'])}`;
        const beneficiaryCountryCode = immScheduledTransfer.getIn(['details', 'beneficiaryCountry']);
        const beneficiaryCountryTranslated = getTranslatedCountry(beneficiaryCountryCode);
        const beneficiaryCountryFormatted = toCamelCase(beneficiaryCountryTranslated);

        return (
            <div className="remove-scheduled-transfer-security-confirmation__informative-list-content">
                <div>
                    <span className="remove-scheduled-transfer-security-confirmation__informative-list-text">
                        {beneficiaryName}
                    </span>
                </div>
                <div>
                    {beneficiaryIban}
                </div>
                <div>
                    {beneficiaryCountryFormatted}
                </div>
            </div>
        );
    }

    buildAmountContent() {
        const { immScheduledTransfer } = this.props;
        const plainAmountObject = getPlainAmountObject(immScheduledTransfer.get('amount'));

        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                className="remove-scheduled-transfer-security-confirmation__informative-list-text"
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
    }

    buildOriginContent() {
        const { immAccount } = this.props;
        const origin = immAccount.get('alias');
        const iban = `IBAN ${immAccount.get('iban')}`;

        return (
            <div className="remove-scheduled-transfer-security-confirmation__informative-list-content">
                <div className="remove-scheduled-transfer-security-confirmation__informative-list-text">
                    {origin}
                </div>
                <div>
                    {iban}
                </div>
            </div>
        );
    }

    handleCancelClick() {
        this.props.history.push(this.props.backUrl);
    }

    handleRemoveClick() {
        const { onRemoveClick, accountId, transferId } = this.props;
        onRemoveClick(accountId, transferId);
    }

    render() {
        const { immScheduledTransfer, immAccount, isRemoving } = this.props;
        const originContent = this.buildOriginContent();
        const beneficiaryContent = this.builBeneficiaryContent();
        const amountContent = this.buildAmountContent();
        const title = formatText('transfersScheduled-removeScheduledTransferTitle');
        const dateContent = DateHelper.customFormat(
            immScheduledTransfer.get('startDate'),
            DATE_FORMAT_ES
        );

        let periodicityBlock;
        if (immScheduledTransfer.get('transferType') !== DEFERRED_TRANFERS) {
            const periodicityText = immScheduledTransfer.getIn(['details', 'periodicityText'])
            const isCCTransfer = periodicityText === CC_PERIODICITY_DAILY || periodicityText === CC_PERIODICITY_WEEKLY || periodicityText === CC_PERIODICITY_CUSTOM
            const periodicityContent = (isCCTransfer) ? formatText(`transfersScheduled-${periodicityText}`) : formatText('transfersScheduled-' + periodicityText);

            periodicityBlock = (
                <OKInformativeListItem
                    title="transfersScheduled-periodicity"
                    bodyText={periodicityContent}
                />
            );
        }

        const operationParams = {
            destinationAccount:
                immScheduledTransfer.getIn(['details', 'beneficiaryFullIban']) ||
                immScheduledTransfer.getIn(['details', 'accountNumber']),
            originAccount:
                API_ENTERPRISE_NUMBER +
                API_CENTER +
                immAccount.get('newProduct') +
                immAccount.get('newContractNumber'),
            ammount: immScheduledTransfer.getIn(['amount', 'amount']),
            currency: immScheduledTransfer.getIn(['amount', 'currency'])
        };

        const operative = formatText('operatives-removeScheduledTransfer');

        return (
            <OKSectionBox className="remove-scheduled-transfer-view__content">
                <OKBoxTitle value={title}/>

                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>

                <p className="remove-scheduled-transfer-security-confirmation__confirmation-message">
                    <FormattedText value="transfersScheduled-removeScheduledTransferMessage" />
                </p>
                <div className="remove-scheduled-transfer-security-confirmation__informative-list">
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem title="transfersScheduled-origin">
                            {originContent}
                        </OKInformativeListItem>
                        <OKInformativeListItem
                            title="transfersScheduled-concept"
                            bodyText={immScheduledTransfer.get('concept')}
                        />
                        <OKInformativeListItem title="transfersScheduled-beneficiary">
                            {beneficiaryContent}
                        </OKInformativeListItem>
                        <OKInformativeListItem
                            title="transfersScheduled-date"
                            bodyText={dateContent}
                        />
                        <OKInformativeListItem title="transfersScheduled-amount">
                            {amountContent}
                        </OKInformativeListItem>
                        {periodicityBlock}
                    </OKInformativeList>
                </div>

                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}/>
                </ContactCenterRender>

                <div className="remove-scheduled-transfer-security-confirmation__signature">
                    <SignaturePattern
                        operationType={REMOVE_SCHEDULED_TRANSFER_ID}
                        operationParams={operationParams}
                    />
                </div>
                <footer className="text-right remove-scheduled-transfer-security-confirmation__footer">
                    <div className="pull-left">
                        <OKButton
                            id="btnRemoveScheduledTransferCancel"
                            modifier="link-ghost"
                            onClick={this.handleCancelClick}
                        >
                            <FormattedText value="transfersScheduled-cancel" />
                        </OKButton>
                    </div>
                    <SignaturePatternButton onClick={this.handleRemoveClick} loading={isRemoving}>
                        <FormattedText value="transfersScheduled-removeScheduledTransferTitleBtnTxt" />
                    </SignaturePatternButton>
                </footer>
            </OKSectionBox>
        );
    }
}

RemoveScheduledTransferSecurityConfirmation.propTypes = {
    accountId: PropTypes.string,
    transferId: PropTypes.string,
    isRemoving: PropTypes.bool,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object,
    immScheduledTransfer: PropTypes.object,
    onRemoveClick: PropTypes.func.isRequired,
    backUrl: PropTypes.string.isRequired
};

module.exports = withRouter(RemoveScheduledTransferSecurityConfirmation);
